import logo from "assets/img/logo/logo_aig_login-2.png";
import React from "react";
import LoadingScreen from "react-loading-screen";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Page from "../../Page";
import { Alert, Button, Card, CardBody, Col, Label, Row } from "reactstrap";
import { Textbox, Select, Radiobox } from "react-inputs-validation";
import { urlGuardarPlanesPagoPolizasEmitidas, urlObtenerPlanesPago, urlObtenerPlanesPagoPolizasEmitidasInfo } from "../../../constants/urls";
import { expresionesRegulares } from "../../../constants";
import { FetchListadoEntidadesFinancieras } from "../../../redux/actions/aEndososBeneficiarios";
import { obtenerCatalogoPaises } from "../../../api/catalogos/catalogoService";
import moment from "moment";
import Select1 from 'react-select';
import { withToastManager } from "react-toast-notifications";

class ListaEndosos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paso: "listado",
            formularioPlanesPago: {
            },
            formulario: {
                titularEsPagador: true,
                valorEstimado: 0.00
            },
            validaciones: {
                banco: true,
                nacionalidad: false,

            },
            entidadesFinancierasSelect: [],
            validate: false,
            loading: false,
            listaPaises: [],
            listaCiudades: [{
                "id": "",
                "name": "Selecione una ciudad"
            }],
            planesPago: [{
                "id": "",
                "name": "Seleccione un plan"
            }],
            maxDate: null,
            submitEnter: false
        }
    }


    getPlanesPago = async (params) => {
        const { toastManager } = this.props;
        this.setState({ loading: true });
        const { body } = this.state;
        await fetch(urlObtenerPlanesPago, {
            method: 'POST',
            body: JSON.stringify({
                ...body,
                banco: params.value
            })
        })
            .then((response) => response.json())
            .then((data) => {

                if (data.transaccion) {
                    this.setState({
                        planesPago: data.data,
                    });
                    this.setState({ loading: false });
                } else {
                    this.setState((prevState) => ({
                        planesPago: [{
                            "id": "",
                            "name": "Seleccione un plan"
                        }],
                        formulario: {
                            ...prevState.formulario,
                            planPago: ""
                        }
                    }))
                    toastManager.add(this.getToastContent('Error al obtener planes de pago'), {
                        appearance: 'error',
                    });
                }
            })
            .catch((response) => {
                this.setState({ loading: false });

            });

        this.setState({ loading: false });
    }

    getToastContent = (message) => {
        return (
            <div>
                {message}
            </div>
        );
    }

    getInfoPlanPagoPoliza = async (params) => {
        this.setState({ loading: true });
        await fetch(urlObtenerPlanesPagoPolizasEmitidasInfo, {
            method: 'POST',
            body: JSON.stringify({
                ...params
            })
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.transaccion) {
                    if (data.data) {
                        this.setState({
                            formularioPlanesPago: data.data,
                            formulario: data.data.planPagPolEmDatosPagador ? data.data.planPagPolEmDatosPagador : {
                                titularEsPagador: true
                            }
                        }, () => {
                            if (data.data && data.data.planPagPolEmDatosPagador) {
                                this.props.onChangeProvincia(
                                    data.data.planPagPolEmDatosPagador.provincia
                                );
                                this.getPlanesPago(data.data.planPagPolEmDatosPagador.banco)
                                this.state.validaciones.banco = false;
                                this.setState((prevState) => ({
                                    validaciones: {
                                        ...prevState.validaciones,
                                        banco: false
                                    }
                                }))
                            }
                        });
                    }

                    this.setState({ loading: false });

                } else {

                }
            })
            .catch((response) => {
                this.setState({ loading: false });

            });

        this.setState({ loading: false });
    }

    obtenerPaises = async () => {
        const resp = await obtenerCatalogoPaises();
        if (resp && resp.transaccion && Array.isArray(resp.paises)) {
            const paises = [{
                "id": "",
                "name": "Seleccione su nacionalidad "
            }];
            const listaPaises = resp.paises.map(pais => ({
                id: pais.paiCodigoCore,
                name: pais.paiNombre
            }));
            this.setState({ listaPaises: paises.concat(listaPaises) });
            return listaPaises;
        }
        return [];
    }

    guardarFormulario = async (e) => {
        e.preventDefault();
        this.setState({
            validate: true,
            submitEnter: true
        }, async () => {
            const { toastManager } = this.props;
            const { formulario, formularioPlanesPago } = this.state;
            const noValido = this.validarFormulario();
            if (noValido) {
                toastManager.add(this.getToastContent('Verifique los datos del formulario.'), {
                    appearance: 'error',
                });
                return;
            }
            this.setState({ loading: true });
            await fetch(urlGuardarPlanesPagoPolizasEmitidas, {
                method: 'POST',
                body: JSON.stringify({
                    id: formularioPlanesPago["_id"],
                    formulario
                })
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.transaccion) {
                        toastManager.add(this.getToastContent(data.message || 'Plan de pagos ha sido guardado exitosamente.'), {
                            appearance: 'success',
                        });
                        this.props.history.push({
                            pathname: "/polizas-emitidas-vigentes",
                        });
                    } else {
                        toastManager.add(this.getToastContent(data.error || 'Error al guardar los datos'), {
                            appearance: 'error',
                        });
                    }
                })
                .catch((response) => {
                    this.setState({ loading: false });
                });
            this.setState({ loading: false });
            return;
        });

    }

    validarFormulario = () => {
        const { validaciones } = this.state;
        const validar = Object.values(validaciones);
        return validar.find((el) => el === true);
    }

    async componentDidMount() {
        const queryParams = new URLSearchParams(this.props.location.search);
        const nro_pol = queryParams.get("poliza");
        const Sucursal = queryParams.get("sucursal");
        const ramo = queryParams.get("ramo");
        const id_pv = queryParams.get("idpv");
        const body = {
            nro_pol,
            Sucursal,
            ramo,
            id_pv,
            empCodigo: "AIGMETROPOLITANA"
        };
        const maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() - 18);
        this.getInfoPlanPagoPoliza(body)
        this.setState({ body });
        const entidadesFinancieras = await this.props.listarEntidadesFinancieras({
            "empCodigo": "AIGMETROPOLITANA",
            "byIds": true
        });
        this.obtenerPaises();

        this.setState({
            maxDate,
            entidadesFinancierasSelect: entidadesFinancieras,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            (this.props.catalogos !== null && this.props.catalogos !== undefined) &&
            (prevProps.catalogos !== null && prevProps.catalogos !== undefined)
            && this.props.catalogos.ciudades !== prevProps.catalogos.ciudades) {
            this.setState({
                listaCiudades: this.props.catalogos.ciudades
            });
        }

    }



    renderDataRamo = () => {
        return (
            <div>
                <Row style={{ marginLeft: 0 }}>
                    <Col style={{ marginBottom: 0 }}>
                        <Row>
                            <Col md={5} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                Póliza:
                            </Col>
                            <Col md={7} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                {this.state.formularioPlanesPago.planPagPolEmPoliza}
                            </Col>
                        </Row>
                    </Col>
                    <Col style={{ marginBottom: 0 }}>
                        <Row>
                            <Col md={5} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                Ramo:
                            </Col>
                            <Col md={7} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                {this.state.formularioPlanesPago.planPagPolEmRamo}
                            </Col>
                        </Row>
                    </Col>
                    <Col style={{ marginBottom: 0 }}>
                        <Row>
                            <Col md={5} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                Sucursal:
                            </Col>
                            <Col md={7} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                {this.state.formularioPlanesPago.planPagPolEmSucursal}
                            </Col>
                        </Row>
                    </Col>
                    <Col style={{ marginBottom: 0 }}>
                        <Row>
                            <Col md={5} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                IDPV:
                            </Col>
                            <Col md={7} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                {this.state.formularioPlanesPago.planPagPolEmIdPv}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row style={{ marginLeft: 0 }}>
                    <Col style={{ marginBottom: 0 }}>
                        <Row>
                            <Col md={5} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                Inicio vigencia:
                            </Col>
                            <Col md={7} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                {this.state.formularioPlanesPago.planPagPolEmFecIniVig}
                            </Col>
                        </Row>
                    </Col>
                    <Col style={{ marginBottom: 0 }}>
                        <Row>
                            <Col md={5} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                Fin vigencia:
                            </Col>
                            <Col md={7} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                {this.state.formularioPlanesPago.planPagPolEmFecFinVig}
                            </Col>
                        </Row>
                    </Col>
                    <Col style={{ marginBottom: 0 }}>
                        <Row>
                            <Col md={5} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                Cédula/RUC:
                            </Col>
                            <Col md={7} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                {this.state.formularioPlanesPago.planPagPolEmIdContratante}
                            </Col>
                        </Row>
                    </Col>
                    <Col style={{ marginBottom: 0 }}>
                        <Row>
                            <Col md={5} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                Contratante:
                            </Col>
                            <Col md={7} style={{ marginBottom: 0, paddingRight: 0, paddingLeft: 0 }}>
                                {this.state.formularioPlanesPago.planPagPolEmNombreContratante}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row style={{ marginLeft: 0 }}>

                </Row>
            </div>

        )
    }

    renderFormularioDatosPagador = () => {
        const {
            formulario,
            validate,
            validaciones,
            listaCiudades
        } = this.state;

        return (
            <div>
                <Row>
                    <Col style={{ marginTop: 10 }}>
                        <h2 style={{ marginBottom: 0 }}>
                            Datos de pagador
                        </h2>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Persona que autoriza el débito automático
                        </Label>
                    </Col>
                </Row>

                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Tipo de identificación
                        </Label>
                        <Select
                            tabIndex="6"
                            id={"tipoIdentificacion"}
                            name={"tipoIdentificacion"}
                            validate={validate}
                            optionList={[
                                { id: "", name: "Seleccione el tipo de identificación" },
                                { id: 'CED', name: 'Cédula' },
                                { id: 'PAS', name: 'Pasaporte' },
                                { id: 'RUC', name: 'RUC' }
                            ]}
                            onChange={(tipoIdSelected, e) => {
                                this.setState((prevState) => {
                                    formulario.tipoIdentificacion = tipoIdSelected;
                                    return {
                                        formulario
                                    }
                                });
                            }}
                            value={
                                formulario.tipoIdentificacion
                            }
                            validationCallback={(res) => {
                                validaciones.tipoIdentificacion = res
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            validationOption={{
                                name: "tipoIdentificacion", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un tipo de identificación",
                            }}
                        />
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Número de identificación
                        </Label>
                        <Textbox
                            id="identificacion"
                            name="identificacion"
                            maxlength="10"
                            tabIndex="1"
                            type="text"
                            classNameInput={"form-control"}
                            validate={validate}
                            value={
                                formulario.identificacion
                            }
                            onChange={(identificacion, e) => {
                                this.setState((prevState) => {
                                    formulario.identificacion = identificacion;
                                    return {
                                        formulario
                                    }
                                });
                            }}
                            validationCallback={(res) => {
                                validaciones.identificacion = res
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            validationOption={{
                                name: "identificacion", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true,
                                customFunc: (value) => {
                                    const tipo = formulario.tipoIdentificacion;
                                    switch (tipo) {
                                        case "CED":
                                            return /^\d{10}$/.test(value);

                                        case "RUC":
                                            return /^\d{13}$/.test(value);

                                        case "PAS":
                                            return /^[A-Za-z0-9]{6,20}$/.test(value);

                                        default:
                                            return false;
                                    }
                                },
                                msgOnError: "Por favor ingrese un número de identificación válido"
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Nombre / Razón Social
                        </Label>
                        <Textbox
                            id="razonSocial"
                            name="razonSocial"
                            type="text"
                            maxlength="10"
                            tabIndex="1"
                            classNameInput={"form-control"}
                            validate={validate}
                            onChange={(razonSocial, e) => {
                                formulario.razonSocial = razonSocial;
                                this.setState((prevState) => {
                                    return {
                                        formulario
                                    }
                                });
                            }}
                            value={
                                formulario.razonSocial
                            }
                            validationCallback={(res) => {
                                validaciones.razonSocial = res;
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            validationOption={{
                                name: "razonSocial", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true,
                                msgOnError: "Ingrese el nombre o razón social del pagador"
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Provincia
                        </Label>
                        <Select
                            tabIndex="6"
                            id={"provincia"}
                            name={"provincia"}
                            validate={validate}
                            optionList={this.props.catalogos.provincias}
                            customStyleOptionListContainer={{
                                maxHeight: "200px",
                                overflow: "auto",
                                fontSize: "14px",
                            }}
                            onChange={(provinciaSelected, e) => {
                                formulario.provincia = provinciaSelected;
                                formulario.ciudad = "";
                                this.props.onChangeProvincia(
                                    provinciaSelected
                                );
                                this.setState((prevState) => {
                                    return {
                                        formulario
                                    }
                                });
                            }}
                            value={
                                formulario.provincia
                            }
                            validationCallback={(res) => {
                                validaciones.provincia = res;
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            validationOption={{
                                name: "provincia", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione una provincia",
                            }}
                        />
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Ciudad
                        </Label>
                        <Select
                            id={"ciudad"} // Optional.[String].Default: "". Input ID.
                            name={"ciudad"} // Optional.[String].Default: "". Input name.
                            value={formulario.ciudad} // Optional.[String].Default: "".
                            optionList={listaCiudades} // Required.[Array of Object(s)].Default: [].
                            validate={validate}
                            tabIndex="6"
                            disabled={formulario.provincia === null || formulario.provincia === undefined}
                            customStyleOptionListContainer={{
                                maxHeight: "200px",
                                overflow: "auto",
                                fontSize: "14px",
                            }}
                            onChange={(ciudadSelected, e) => {
                                this.setState((prevState) => {
                                    formulario.ciudad = ciudadSelected;
                                    return {
                                        formulario
                                    }
                                });
                            }}
                            validationCallback={(res) => {
                                validaciones.ciudad = res;
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            validationOption={{
                                name: "ciudad", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione una ciudad",
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Dirección
                        </Label>
                        <Textbox
                            id={"direccion"}
                            name={"direccion"}
                            type="text"
                            maxlength="10"
                            tabIndex="1"
                            classNameInput={"form-control"}
                            validate={validate}
                            value={
                                formulario.direccion
                            }
                            onChange={(direccion, e) => {
                                formulario.direccion = direccion;
                                this.setState((prevState) => {
                                    return {
                                        formulario
                                    }
                                });
                            }}
                            validationCallback={(res) => {
                                validaciones.direccion = res;
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            validationOption={{
                                name: "direccion", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true,
                                msgOnError: "Ingrese la dirección"
                            }} />
                    </Col>
                </Row>
                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Email
                        </Label>
                        <Textbox
                            tabIndex="1"
                            type="text"
                            id="correo"
                            name="correo"
                            validate={validate}
                            classNameInput={"form-control"}
                            disabled={false}
                            value={formulario.correo}
                            onChange={(correo, e) => {
                                formulario.correo = correo;
                                this.setState({
                                    formulario,
                                });
                            }}
                            validationCallback={(res) => {
                                validaciones.correo = res;
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            validationOption={{
                                name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                reg: expresionesRegulares.email,
                                msgOnError:
                                    "Por favor ingrese un correo electrónico válido",
                            }} />
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Teléfono
                        </Label>
                        <Textbox
                            type="text"
                            id={"telefono"}
                            name={"telefono"}
                            validate={validate}
                            classNameInput={"form-control"}
                            disabled={false}
                            value={formulario.telefono}
                            onChange={(telefono, e) => {
                                formulario.telefono = telefono;
                                this.setState({
                                    formulario,
                                });
                            }}
                            validationCallback={(res) => {
                                validaciones.telefono = res;
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            validationOption={{
                                name: "telefono", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError:
                                    "Por favor ingrese un número de teléfono",
                            }} />
                    </Col>
                </Row>
            </div>
        );
    }

    renderFormularioCuentaBancaria = () => {
        const {
            formulario,
            entidadesFinancierasSelect,
            validate,
            listaPaises,
            validaciones,
            submitEnter,
            maxDate
        } = this.state;
        return (
            <div>
                <Row>
                    <Col style={{ marginTop: 10 }}>
                        <h2 style={{ marginBottom: 0 }}>
                            Cuenta bancaria
                        </h2>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            De dónde se debitará cada cuota
                        </Label>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Banco
                        </Label>
                        <Select1
                            tabIndex="1"
                            id={"banco"}
                            name={"banco"}
                            value={formulario.banco}
                            options={entidadesFinancierasSelect}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    borderColor: submitEnter === true && formulario.banco === undefined ? "#ff5a57" : "hsl(0, 0%, 80%);",
                                }),
                            }}
                            placeholder={
                                "Seleccione la entidad financiera"
                            }
                            customStyleOptionListContainer={{
                                maxHeight: "200px",
                                overflow: "auto",
                                fontSize: "14px",
                            }}
                            isSearchable={true}
                            onChange={(selec, e) => {
                                formulario.banco = selec;
                                validaciones.banco = false;
                                this.setState({ formulario, validaciones }, () => {
                                    this.getPlanesPago(selec)
                                });
                            }}
                            isMulti={false}
                        />
                        {
                            submitEnter === true && formulario.banco === undefined ?
                                <span style={{ color: '#FA5A77', fontSize: 14, }} >Por favor seleccione un banco</span> : <></>
                        }
                    </Col>

                    <Col md={6} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Tipo de cuenta
                        </Label>
                        <Select
                            tabIndex="1"
                            id={"tipoCuenta"}
                            name={"tipoCuenta"}
                            validate={validate}
                            value={formulario.tipoCuenta}
                            optionList={[
                                { "id": "", "name": "Seleccione un tipo de cuenta" },
                                { "id": "Ahorros", "name": "Ahorros" },
                                { "id": "Corriente", "name": "Corriente" },
                            ]}
                            placeholder={
                                "Seleccione la entidad financiera"
                            }
                            customStyleOptionListContainer={{
                                maxHeight: "200px",
                                overflow: "auto",
                                fontSize: "14px",
                            }}
                            validationCallback={(res) => {
                                validaciones.tipoCuenta = res;
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            onChange={(selec, e) => {
                                formulario.tipoCuenta = selec;
                                this.setState({ formulario });
                            }}
                            validationOption={{
                                name: "tipoCuenta", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un tipo de cuenta",
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Número de cuenta
                        </Label>
                        <Textbox tabIndex="1"
                            type="text"
                            id={"numeroCuenta"}
                            name={"numeroCuenta"}
                            validate={validate}
                            classNameInput={"form-control"}
                            disabled={false}
                            value={formulario.numeroCuenta}
                            onChange={(numeroCuenta, e) => {
                                formulario.numeroCuenta = numeroCuenta;
                                this.setState({
                                    formulario,
                                });
                            }}
                            validationCallback={(res) => {
                                validaciones.numeroCuenta = res;
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            validationOption={{
                                name: "numeroCuenta", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                customFunc: (res) => {
                                    return /^\d*$/.test(res)
                                },
                                msgOnError:
                                    "Por favor ingrese un número de cuenta válido",
                            }} />
                    </Col>
                </Row>
                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            ¿El pagador es el titular de la cuenta bancaria?
                        </Label>
                        <Radiobox
                            id="titularEsPagador"
                            name="titularEsPagador"
                            customStyleContainer={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                gap: '20px'
                            }}
                            value={formulario.titularEsPagador}
                            optionList={
                                [
                                    {
                                        "name": "SI",
                                        "id": true
                                    },
                                    {
                                        "name": "NO",
                                        "id": false
                                    }
                                ]
                            }
                            onChange={(titularEsPagador, e) => {
                                formulario.titularEsPagador = titularEsPagador;
                                formulario.nacionalidad = "";
                                formulario.fechaNacimientoCuenta = "";
                                formulario.direccionDomicilio = "";
                                this.setState({
                                    formulario,
                                });
                            }} // Required.[Func].Default: () => {}. Will return the value.
                            customStyleOptionListContainer={{
                                maxHeight: "200px",
                                overflow: "auto",
                                fontSize: "14px",
                            }}
                            onBlur={(e) => { console.log(e) }} // Optional.[Func].Default: none.
                            validate={validate}
                            validationCallback={res => this.setState({ validate: res })} // Optional.[Func].Default: none. Return the validation result.
                            validationOption={{
                                name: 'titularEsPagador', // Optional.[String].Default: "". To display in the Error message. i.e Please enter your .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Seleccione una opción"
                            }}
                        />
                    </Col>
                </Row>
                {!formulario.titularEsPagador &&
                    <>
                        <Row>
                            <Col md={6} sm={12} xs={12}>
                                <Select
                                    id={"nacionalidad"}
                                    name={"nacionalidad"}
                                    onChange={(selec, e) => {
                                        formulario.nacionalidad = selec;
                                        this.setState({ formulario });
                                    }}
                                    validate={validate}
                                    value={formulario.nacionalidad}
                                    validationCallback={(res) => {
                                        validaciones.nacionalidad = res && !formulario.titularEsPagador;
                                        this.setState({
                                            validaciones,
                                            validate: false,
                                        })
                                    }}
                                    validationOption={{
                                        name: "nacionalidad", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                        msgOnError: "Por favor seleccione una nacionalidad",
                                    }}
                                    optionList={listaPaises}
                                    tabIndex="6"
                                    customStyleOptionListContainer={{
                                        maxHeight: "200px",
                                        overflow: "auto",
                                        fontSize: "14px",
                                    }}
                                />
                            </Col>
                            <Col md={6} sm={12} xs={12}>
                                <Textbox
                                    tabIndex="1"
                                    type="date"
                                    id="fechaNacimientoCuenta"
                                    name="fechaNacimientoCuenta"
                                    validate={validate}
                                    classNameInput={"form-control"}
                                    disabled={false}
                                    value={formulario.fechaNacimientoCuenta}
                                    onChange={(fechaNacimientoCuenta, e) => {
                                        formulario.fechaNacimientoCuenta = fechaNacimientoCuenta;
                                        this.setState({
                                            formulario,
                                        });
                                    }}
                                    validationCallback={(res) => {
                                        validaciones.fechaNacimientoCuenta = res && !formulario.titularEsPagador;
                                        this.setState({
                                            validaciones,
                                            validate: false,
                                        })
                                    }}
                                    validationOption={{
                                        name: "fechaNacimientoCuenta", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                        msgOnError: "Por favor seleccione una fecha correcta (debe ser mayor a 18 años)",
                                        customFunc: (res) => {
                                            var diferenciaAnios = moment().diff(new Date(res), 'years');
                                            if (diferenciaAnios < 18) {
                                                return false;
                                            } else {
                                                return true;
                                            }
                                        }
                                    }
                                    } />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} sm={12} xs={12}>
                                <Textbox
                                    id={"direccionDomicilio"}
                                    name={"direccionDomicilio"}
                                    validate={validate}
                                    classNameInput={"form-control"}
                                    disabled={false}
                                    value={formulario.direccionDomicilio}
                                    onChange={(direccionDomicilio, e) => {
                                        formulario.direccionDomicilio = direccionDomicilio;
                                        this.setState({
                                            formulario,
                                        });
                                    }}
                                    validationCallback={(res) => {
                                        validaciones.direccionDomicilio = res && !formulario.titularEsPagador;
                                        this.setState({
                                            validaciones,
                                            validate: false,
                                        })
                                    }}
                                    validationOption={{
                                        name: "direccionDomicilio", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                        msgOnError:
                                            "Por favor ingrese una dirección de domicilio",
                                    }}
                                    placeholder="Dirección domicilio"
                                />
                            </Col>
                        </Row>
                    </>}

            </div>
        );
    }

    renderFormularioPlanPagos = () => {
        const {
            formulario,
            validate,
            planesPago,
            validaciones
        } = this.state;
        return (
            <div>
                <Row>
                    <Col style={{ marginTop: 10 }}>
                        <h2 style={{ marginBottom: 0 }}>
                            Plan de pagos
                        </h2>
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Filtrado por banco seleccionado y amo de la póliza
                        </Label>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Select
                            id="planPago"
                            name="planPago"
                            onChange={(selec, e) => {
                                formulario.planPago = selec;
                                this.setState({ formulario });
                            }}
                            validate={validate}
                            value={formulario.planPago}
                            validationCallback={(res) => {
                                validaciones.planPago = res;
                                this.setState({
                                    validaciones,
                                    validate: false,
                                })
                            }}
                            validationOption={{
                                name: "planPago", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un plan",
                            }}
                            optionList={planesPago}
                            tabIndex="6"
                            customStyleOptionListContainer={{
                                maxHeight: "200px",
                                overflow: "auto",
                                fontSize: "14px",
                            }}
                        />
                        <Label for="Titulo datos pagador" className={"text-muted descripcion-cotizadores"}>
                            Cantidad de cuotas
                        </Label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Alert
                            color="primary"
                            isOpen={true}
                            className={"d-flex justify-content-start align-items-center"}
                        >
                            <i style={{
                                marginRight: '10px',
                                color: "#010410"
                            }} className="fa fa-exclamation-triangle fa-lg" aria-hidden="true" ></i>
                            <p style={{
                                color: "#010410"
                            }}>
                                El débito se realizará del 1 al 5 de cada mes. Solicitamos notificar a su cliente para que cuente con los fondos necesarios.
                            </p>

                        </Alert>
                    </Col>
                </Row>
                <Row style={{ marginTop: "30px", marginBottom: "100px" }}>
                    <Col style={{ display: "flex", justifyContent: "end" }}>
                        <Button
                            className="btn btn-white"
                            onClick={() => {
                                this.props.history.push({
                                    pathname: "/polizas-emitidas-vigentes",
                                });
                            }}
                            style={{
                                display: "block",
                                width: "210px"
                            }}
                        >
                            {` Cancelar`} {/* ${NumUbicacion} */}
                        </Button>
                    </Col>
                    <Col style={{ display: "flex", justifyContent: "start" }}>
                        <Button
                            className="btn btn-primary"
                            onClick={(e) => {
                                this.guardarFormulario(e);
                            }}
                            style={{
                                display: "block",
                                width: "210px"
                            }}
                        >
                            {` Guardar`} {/* ${NumUbicacion} */}
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }

    render() {
        const {
            catalogos
        } = this.props;
        return (
            <LoadingScreen
                loading={this.state.loading || catalogos.listarCiudadesIsLoading}
                bgColor="#f1f1f1"
                spinnerColor="#001871"
                textColor="#676767"
                logoSrc={logo}
                text={"Obteniendo registros..."}
            >
                <Page
                    title={
                        ""
                    }
                >

                    <div className="div-align-center col-12 col-sm-12 col-md-12 col-lg-11 mb-3">
                        <h1>Plan de pagos</h1>
                    </div>
                    <Card>
                        <CardBody className="div-align-center col-12 col-sm-12 col-md-12 col-lg-11">
                            <Row>
                                <Col style={{ marginTop: 20, marginBottom: 20 }}>
                                    <h3>
                                        Datos póliza
                                    </h3>
                                </Col>
                            </Row>


                            {this.renderDataRamo()}
                            <hr></hr>
                            {this.renderFormularioDatosPagador()}
                            <hr></hr>
                            {this.renderFormularioCuentaBancaria()}
                            <hr></hr>
                            {this.renderFormularioPlanPagos()}
                        </CardBody>
                    </Card>
                </Page>
            </LoadingScreen>
        );
    }
}

const mapStateToProps = (state) => ({
    datosEndosos: state.dataEndosos ? state.dataEndosos : false,
    catalogos: state.catalogosCotizacion
});

const mapDispatchToProps = (dispatch) => {
    return {
        listarEntidadesFinancieras: (params) => dispatch(FetchListadoEntidadesFinancieras(params)),
    };
};

export default withToastManager(withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ListaEndosos)
));